import { render } from "./hot.vue?vue&type=template&id=74ede785&scoped=true&ts=true"
import script from "./hot.vue?vue&type=script&lang=ts"
export * from "./hot.vue?vue&type=script&lang=ts"

import "./hot.vue?vue&type=style&index=0&id=74ede785&lang=less"
import "./hot.vue?vue&type=style&index=1&id=74ede785&lang=less&scoped=true"
import "./hot.vue?vue&type=style&index=2&id=74ede785&lang=less"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ede785"]])

export default __exports__